const testQueriesUpdated = [
  {
    "Query": "When is the meeting with Keith",
    "Current-query": "",
    "Entity": "/",
    "Platform": "Gmail",
    "Groundtruth": "<SN6PR11MB28803FACECF9734831E742D2DB969@SN6PR11MB2880.namprd11.prod.outlook.com>",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "O365",
    "Groundtruth": "<SN6PR11MB28803FACECF9734831E742D2DB969@SN6PR11MB2880.namprd11.prod.outlook.com>",
    "Account": "cloud@gotrova.ai",
    "Channel": "",
    "test-account": "test@gotrova.ai",
    "": ""
  },
  {
    "Query": "social media budget July",
    "Current-query": "",
    "Entity": "/",
    "Platform": "Gmail",
    "Groundtruth": "<99E969C3-0F78-4D8F-B584-C506F756E7E6@personifyinc.com>",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "O365",
    "Groundtruth": "<99E969C3-0F78-4D8F-B584-C506F756E7E6@personifyinc.com>",
    "Account": "cloud@gotrova.ai",
    "Channel": "",
    "test-account": "test@gotrova.ai",
    "": ""
  },
  {
    "Query": "responsive design link",
    "Current-query": "",
    "Entity": "Link",
    "Platform": "slack",
    "Groundtruth": "https://trova-hq.slack.com/archives/C024Z93DBHN/p1624372736000200",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "testingreleases",
    "test-account": "test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "privacy policy",
    "Current-query": "",
    "Entity": "File/Link",
    "Platform": "Gdrive",
    "Groundtruth": "https://drive.google.com/file/d/1L4QhfZViOAiYLj60zVTT0YLi35cE1Mm_/view?usp=sharing",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "AI baby crib sent to Byron",
    "Current-query": "AI crib Byron",
    "Entity": "File",
    "Platform": "Gmail",
    "Groundtruth": "<CAKVuy5FjE8WJW=Df+OEMSWXrAgJkdzmaBObKnX2WPzCt3jDJXA@mail.gmail.com>",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "O365",
    "Groundtruth": "<CAKVuy5FjE8WJW=Df+OEMSWXrAgJkdzmaBObKnX2WPzCt3jDJXA@mail.gmail.com>",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai",
    "": ""
  },
  {
    "Query": "MacBook suggestions",
    "Current-query": "",
    "Entity": "File",
    "Platform": "Gmail",
    "Groundtruth": "<CAKng2fHB9iTdgWz4NXJm149ZgPe_V9=v6JzcJ3P=oG+61crxMQ@mail.gmail.com>",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "O365",
    "Groundtruth": "<CAKng2fHB9iTdgWz4NXJm149ZgPe_V9=v6JzcJ3P=oG+61crxMQ@mail.gmail.com>",
    "Account": "cloud@gotrova.ai",
    "Channel": "",
    "test-account": "test@gotrova.ai",
    "": ""
  },
  {
    "Query": "Slack link sent by Long",
    "Current-query": "",
    "Entity": "Link",
    "Platform": "Gmail",
    "Groundtruth": "<CAL43u-VYpgEWc2W6wT_nutXvPwBA7UEVN7kxfjS-3bew6Td0bA@mail.gmail.com>",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "O365",
    "Groundtruth": "<CAL43u-VYpgEWc2W6wT_nutXvPwBA7UEVN7kxfjS-3bew6Td0bA@mail.gmail.com>",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai",
    "": ""
  },
  {
    "Query": "Development log written by Sanjay",
    "Current-query": "Development log Sanjay",
    "Entity": "File",
    "Platform": "Gmail",
    "Groundtruth": "<00000000000061156205c431f6ab@google.com>",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "GDrive",
    "Groundtruth": "https://docs.google.com/presentation/d/1K5ry72R9APmH_s3B4qI57CBT8OR-mlimB3WA0iAPUfQ/edit",
    "Account": "",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "Slack",
    "Groundtruth": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1622234816033700",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "general",
    "test-account": "test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "Teams",
    "Groundtruth": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625609678983?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625594727139&teamName=gotrova.ai&channelName=Testing&createdTime=1625609678983",
    "Account": "cloud@gotrova.ai",
    "Channel": "#Testing",
    "test-account": "test@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "O365",
    "Groundtruth": "<00000000000061156205c431f6ab@google.com>",
    "Account": "cloud@gotrova.ai",
    "Channel": "",
    "test-account": "test@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "Jira",
    "Groundtruth": "https://gotrova.atlassian.net/browse/BAC-91",
    "Account": "cloud@gotrova.ai",
    "Channel": "",
    "test-account": "test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "Heting search history",
    "Current-query": "",
    "Entity": "File",
    "Platform": "Gmail",
    "Groundtruth": "<01000179d8d27c5b-69603b1f-d79e-417a-8b3c-2c78401e89ba-000000@email.amazonses.com>",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "GDrive",
    "Groundtruth": "https://docs.google.com/spreadsheets/d/1B8TuhWlWkQXvzWPeABAsCdEXZj2xGO_67xbmw_MjI_Y/edit?usp=sharing",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "O365",
    "Groundtruth": "<01000179d8d27c5b-69603b1f-d79e-417a-8b3c-2c78401e89ba-000000@email.amazonses.com>",
    "Account": "cloud@gotrova.ai",
    "Channel": "",
    "test-account": "test@gotrova.ai",
    "": ""
  },
  {
    "Query": "Survey by Elena",
    "Current-query": "",
    "Entity": "File",
    "Platform": "Gmail",
    "Groundtruth": "<SA2PR11MB5036FB5684261FDC42E04B7B89389@SA2PR11MB5036.namprd11.prod.outlook.com>",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "Slack",
    "Groundtruth": "https://trova-hq.slack.com/archives/C024Z93DBHN/p1623095357002500",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "testingreleases",
    "test-account": "test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "O365",
    "Groundtruth": "<SA2PR11MB5036FB5684261FDC42E04B7B89389@SA2PR11MB5036.namprd11.prod.outlook.com>",
    "Account": "cloud@gotrova.ai",
    "Channel": "",
    "test-account": "test@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "GDrive",
    "Groundtruth": "https://docs.google.com/forms/d/1beGLVYaRYwGosVQK3faIu0LHvQXV2ej59mtAEqWYfe0/edit?usp=sharing",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "Resume folder shared by Sanjay",
    "Current-query": "Resume folder Sanjay",
    "Entity": "Link",
    "Platform": "GDrive",
    "Groundtruth": "https://drive.google.com/drive/folders/1hvJ2ZwHwlYDxaaVmE6y0Ezf11mRU5c-H?usp=sharing",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "Bug tracker from Surendra",
    "Current-query": "Bug tracker surendra",
    "Entity": "Link",
    "Platform": "Slack",
    "Groundtruth": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1620929956003700",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "General",
    "test-account": "test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "Payne article shared with Elena",
    "Current-query": "payne article",
    "Entity": "File",
    "Platform": "GDrive",
    "Groundtruth": "https://drive.google.com/file/d/1FlknYj9HpsMAuMGgFBQWQi9R78wPiuup/view?usp=sharing",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "Preproposal shared on Slack",
    "Current-query": "Preproposal",
    "Entity": "File",
    "Platform": "GDrive",
    "Groundtruth": "https://docs.google.com/document/d/123Ab3fTl1W6C880KBvZkIW1-ww0btmXbF8m0F4xCliM/edit?usp=sharing",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "Information management",
    "Current-query": "",
    "Entity": "File",
    "Platform": "GDrive",
    "Groundtruth": "https://drive.google.com/file/d/1XTgZ6MMBgjB-_7FnWzbm6DYD6Bm8TStV/view?usp=sharing",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "Maize order on slack",
    "Current-query": "",
    "Entity": "Link",
    "Platform": "Slack",
    "Groundtruth": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1622219909032200",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "General",
    "test-account": "test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "Trove",
    "Current-query": "",
    "Entity": "File",
    "Platform": "Gmail",
    "Groundtruth": "<000000000000b24a5105c431d9f0@google.com>",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "Slack",
    "Groundtruth": "https://trova-hq.slack.com/archives/C01TMEP2W0K/p1621532313009600",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "standup",
    "test-account": "test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "GDrive",
    "Groundtruth": "https://docs.google.com/spreadsheets/d/1kxog0TtcNB3qmiMWNau5M2KW0qsisjwmcblDf7rvx8Y/edit#gid=1681070096",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "O365",
    "Groundtruth": "https://gotrovaai-my.sharepoint.com/:x:/g/personal/cloud_gotrova_ai/EWbbwvlj3ihHhUKtOAj0juUBNOCtOlF0CJShLdgAu2QK3w?e=lUvEzM",
    "Account": "cloud@gotrova.ai",
    "Channel": "",
    "test-account": "test@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "Teams",
    "Groundtruth": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625626398652?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625626296131&teamName=gotrova.ai&channelName=Testing&createdTime=1625626398652",
    "Account": "cloud@gotrova.ai",
    "Channel": "testing",
    "test-account": "test@gotrova.ai",
    "": ""
  },
  {
    "Query": "Trova address",
    "Current-query": "",
    "Entity": "Location",
    "Platform": "Slack",
    "Groundtruth": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1616180166001200",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "general",
    "test-account": "test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "Teams",
    "Groundtruth": "",
    "Account": "",
    "Channel": "",
    "test-account": "test@gotrova.ai",
    "": ""
  },
  {
    "Query": "Surendra number",
    "Current-query": "",
    "Entity": "Phone number",
    "Platform": "Gmail",
    "Groundtruth": "<91C1CE8F-1DCE-498F-BCA3-8000D86880B1@personifyinc.com>",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "O365",
    "Groundtruth": "<91C1CE8F-1DCE-498F-BCA3-8000D86880B1@personifyinc.com>",
    "Account": "cloud@gotrova.ai",
    "Channel": "",
    "test-account": "test@gotrova.ai",
    "": ""
  },
  {
    "Query": "New year meeting info",
    "Current-query": "",
    "Entity": "Event",
    "Platform": "Gmail",
    "Groundtruth": "<00000000000050d8aa05b980cf52@google.com>",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "O365",
    "Groundtruth": "<00000000000050d8aa05b980cf52@google.com>",
    "Account": "cloud@gotrova.ai",
    "Channel": "",
    "test-account": "test@gotrova.ai",
    "": ""
  },
  {
    "Query": "Github account",
    "Current-query": "",
    "Entity": "Email address",
    "Platform": "Gmail",
    "Groundtruth": "<5015493B-96F9-4465-BB40-099503A7F750@personifyinc.com>",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": ""
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "O365",
    "Groundtruth": "<5015493B-96F9-4465-BB40-099503A7F750@personifyinc.com>",
    "Account": "cloud@gotrova.ai",
    "Channel": "",
    "test-account": "test@gotrova.ai",
    "": ""
  },
  {
    "Query": "survey link from holly",
    "Current-query": "survey link Holly",
    "Entity": "File",
    "Platform": "Slack",
    "Groundtruth": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1621282712010600",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "general",
    "test-account": "test1@gotrova.ai",
    "": "Baseline"
  },
  {
    "Query": "development log",
    "Current-query": "",
    "Entity": "File",
    "Platform": "Gmail",
    "Groundtruth": "<00000000000061156205c431f6ab@google.com>",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": "Baseline"
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "GDrive",
    "Groundtruth": "https://docs.google.com/presentation/d/1K5ry72R9APmH_s3B4qI57CBT8OR-mlimB3WA0iAPUfQ/edit",
    "Account": "",
    "Channel": "",
    "test-account": "test@gotrova.ai, test1@gotrova.ai",
    "": "Baseline"
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "Slack",
    "Groundtruth": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1622234816033700",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "general",
    "test-account": "test1@gotrova.ai",
    "": "Baseline"
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "Teams",
    "Groundtruth": "https://teams.microsoft.com/l/message/19:006bd7dac304480d834c5bba1348d106@thread.tacv2/1625609678983?tenantId=1dbb5bc3-2b94-4b60-b5e0-163d3e548bcc&groupId=ae1915fa-cd49-4000-b916-becbf202b6eb&parentMessageId=1625594727139&teamName=gotrova.ai&channelName=Testing&createdTime=1625609678983",
    "Account": "cloud@gotrova.ai",
    "Channel": "#Testing",
    "test-account": "test@gotrova.ai",
    "": "Baseline"
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "O365",
    "Groundtruth": "<00000000000061156205c431f6ab@google.com>",
    "Account": "cloud@gotrova.ai",
    "Channel": "",
    "test-account": "test@gotrova.ai",
    "": "Baseline"
  },
  {
    "Query": "",
    "Current-query": "",
    "Entity": "",
    "Platform": "Jira",
    "Groundtruth": "https://gotrova.atlassian.net/browse/BAC-91",
    "Account": "cloud@gotrova.ai",
    "Channel": "",
    "test-account": "test1@gotrova.ai",
    "": "Baseline"
  },
  {
    "Query": "IAM user credential",
    "Current-query": "",
    "Entity": "-",
    "Platform": "Slack",
    "Groundtruth": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1622834903056900",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "general",
    "test-account": "test1@gotrova.ai",
    "": "Baseline"
  },
  {
    "Query": "whiteboard image shared by Kevin",
    "Current-query": "whiteboard image Kevin",
    "Entity": "File",
    "Platform": "Slack",
    "Groundtruth": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1622145717029500",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "general",
    "test-account": "test1@gotrova.ai",
    "": "Baseline"
  },
  {
    "Query": "grubhub link from Sanjay",
    "Current-query": "",
    "Entity": "Link",
    "Platform": "Slack",
    "Groundtruth": "https://trova-hq.slack.com/archives/C01HS31CKGS/p1622824292055300",
    "Account": "trova.searchtest@gmail.com",
    "Channel": "general",
    "test-account": "test1@gotrova.ai",
    "": "Baseline"
  },
  {
    "Query": "problem new membership from Shuchen Zhang",
    "Current-query": "problem new membership",
    "Entity": "",
    "Platform": "Jira",
    "Groundtruth": "https://gotrova.atlassian.net/browse/SD-925",
    "Account": "cloud@gotrova.ai",
    "Channel": "",
    "test-account": "test1@gotrova.ai",
    "": "Baseline"
  },
  {
    "Query": "Invalid product name",
    "Current-query": "Invalid product name",
    "Entity": "",
    "Platform": "Jira",
    "Groundtruth": "https://gotrova.atlassian.net/browse/SD-918",
    "Account": "cloud@gotrova.ai",
    "Channel": "",
    "test-account": "test1@gotrova.ai",
    "": "Baseline"
  },
  {
    "Query": "portal skins screenshots from Kevin sent to Omer",
    "Current-query": "portal skins screenshots",
    "Entity": "",
    "Platform": "Jira",
    "Groundtruth": "https://gotrova.atlassian.net/browse/SD-914",
    "Account": "cloud@gotrova.ai",
    "Channel": "",
    "test-account": "test1@gotrova.ai",
    "": "Baseline"
  },
  {
    "Query": "cross context session sharing last month",
    "Current-query": "cross context session sharing",
    "Entity": "",
    "Platform": "Jira",
    "Groundtruth": "https://gotrova.atlassian.net/browse/SD-919",
    "Account": "cloud@gotrova.ai",
    "Channel": "",
    "test-account": "test1@gotrova.ai",
    "": "Baseline"
  }
];

export default testQueriesUpdated;